export interface RouteConfig {
  path: string;
  label: string;
  component: string;
}

export const BASE_PATH = '';

export const routes: RouteConfig[] = [
  {
    path: '/',
    label: 'Home',
    component: 'Home'
  },
  {
    path: '/services',
    label: 'Services',
    component: 'Services'
  },
  {
    path: '/services/web-development',
    label: 'Web Development',
    component: 'WebDevelopment'
  },
  {
    path: '/services/responsive-design',
    label: 'Responsive Design',
    component: 'ResponsiveDesign'
  },
  {
    path: '/services/ecommerce-solutions',
    label: 'E-commerce Solutions',
    component: 'EcommerceSolutions'
  },
  {
    path: '/portfolio',
    label: 'Portfolio',
    component: 'Portfolio'
  },
  {
    path: '/about',
    label: 'About',
    component: 'About'
  },
  {
    path: '/contact',
    label: 'Contact',
    component: 'Contact'
  }
];

export const PUBLIC_URL = process.env.PUBLIC_URL || ''; 